import React from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

const LANGUAGES = [
  { code: "uz", label: "UZ", ariaLabel: "O'zbek tili" },
  { code: "ru", label: "RU", ariaLabel: "Русский язык" },
  { code: "en", label: "EN", ariaLabel: "English" },
];

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const current = i18n.language?.slice(0, 2);

  return (
    <div
      role="group"
      aria-label="Language selector"
      className="flex items-center gap-1"
    >
      {LANGUAGES.map((lang) => {
        const isActive = current === lang.code;
        return (
          <button
            key={lang.code}
            onClick={() => i18n.changeLanguage(lang.code)}
            aria-label={lang.ariaLabel}
            aria-pressed={isActive}
            className={clsx(
              "px-2 py-1 rounded text-xs font-bold tracking-wider transition-all duration-200",
              "min-w-[36px] min-h-[28px]",
              "focus-visible:ring-2 focus-visible:ring-aviation-cyan focus-visible:outline-none",
              isActive
                ? "bg-aviation-cyan/20 text-aviation-cyan border border-aviation-cyan/50 shadow-glow"
                : "text-slate-400 border border-transparent hover:text-slate-200 hover:border-slate-600"
            )}
          >
            {lang.label}
          </button>
        );
      })}
    </div>
  );
}
